import { PureComponent } from 'react';
import { TextArea } from 'semantic-ui-react';
import withFormikInput from './withFormikInput';
import withFormField from './withFormField';
import { PropsOf } from 'utils/types.utils';

class _FormTextArea extends PureComponent<PropsOf<typeof TextArea>> {
  render() {
    return <TextArea autoComplete="false" {...this.props} />;
  }
}

const FormTextArea = withFormikInput(
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
  withFormField(_FormTextArea, {
    validators: [(value) => value && value.length < 2048],
  })
);
export default FormTextArea;
